import React from 'react'
import './Floating_Note.css'
import Notes_Lottie from '../../../../animation/notes_lottie/Notes_Lottie'

const Floating_Note = ({label,onClick}) => {
  return (
    <section className='Floating_Note' onClick={onClick}>
      <Notes_Lottie/>
      <p className='inner_text'>{label}</p>
    </section>
  )
}

export default Floating_Note
